



function pageTop() {
  var topBtn = $('#page-top');
  topBtn.hide();
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      topBtn.fadeIn(200);
    } else {
      topBtn.fadeOut(200);
    }
  });
}




function spHeaderBtn() {
  var $btnToggle = $('.btn-toggle');
  $btnToggle.on('click', function() {
    $('.layered-nav').toggleClass('active');
    $(this).toggleClass('active');
    $('.layered-nav li a').on('click', function() {
      $('.layered-nav').removeClass('active');
      $('.btn-toggle').removeClass('active');
    });
  });
}


function btnSearchToggle() {
  $('.btn-search-toggle').on('click', function() {
    $('.global-search').addClass('active');
    $('.global-search-mask').addClass('active');
    $('.search-form__input').focus();
  });
  $('.global-search-mask').on('click', function() {
    $('.global-search').removeClass('active');
    $(this).removeClass('active');
  });
}




//画面読み込み時のローディング画像
$(window).on('load',function(){
  $('#loading-block').fadeOut(300);
});


//スクロールした時
$(window).scroll(function(){

});

//画面のサイズを変えた時
$(window).resize(function(){




});


$(document).ready(function() {

  spHeaderBtn();

  btnSearchToggle();

  //imgLiquid
  //$('.img-liquid').imgLiquid(); //CSSで高さを指定する必要あり



  //アンカーリンクスムーズ
  $('a[href^="#"]').click(function(){
    var speed = 300;
    var href= $(this).attr("href");
    var target = $(href === "#" || href === "" ? 'html' : href);
    const gap = document.getElementById('js-header').offsetHeight; // 固定ヘッダー分の高さ
    var position = target.offset().top - gap;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });


  //トップスライドバナー
  $('.top-main-slider ul').slick({
    // centerMode: true,
    // centerPadding: '60px',
    slidesToShow: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    // responsive: [
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       arrows: false,
    //       centerMode: true,
    //       centerPadding: '40px',
    //       slidesToShow: 3
    //     }
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       arrows: false,
    //       centerMode: true,
    //       centerPadding: '40px',
    //       slidesToShow: 1
    //     }
    //   }
    // ]
  });

  //商品スライダー
  $('.item-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 4000,
    // centerMode: false,
    // variableWidth: false,
    responsive: [
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  //ヘッダー固定・スマホナビ固定
  var _window = $(window),
      _header = $('.header'),
      _spnavi = $('.sp-navi'),
      heroBottom;

  _window.on('scroll',function(){
      heroBottom = $('.announcement').height();
      if(_window.scrollTop() > heroBottom){
          _header.addClass('sticky');
          _spnavi.addClass('sticky');
      }
      else{
          _header.removeClass('sticky');
          _spnavi.removeClass('sticky');
      }
  });

  _window.trigger('scroll');

  //ハンバーガーボタン
  var $btnToggle = $('.btn-hamburger');
  $btnToggle.on('click', function() {
    $('.sp-navi').toggleClass('active');
    $(this).toggleClass('active');
    $('.sp-navi-ul li a').on('click', function() {
      console.log('hh')
      $('.sp-navi').removeClass('active');
      $btnToggle.removeClass('active');
    });
  });






});



$(function(){

  var arySpinnerCtrl = [];
  var spin_speed = 20; //変動スピード

  //長押し押下時
  // $('.btnspinner').on('touchstart mousedown click blur', function(e){
  $('.btnspinner').on('click blur', function(e){
      if(arySpinnerCtrl['interval']) return false;
      var target = $(this).data('target');
      arySpinnerCtrl['target'] = target;
      arySpinnerCtrl['timestamp'] = e.timeStamp;
      arySpinnerCtrl['cal'] = Number($(this).data('cal'));

      //クリックは単一の処理に留める
      if(e.type == 'click'){
          spinnerCal();
          arySpinnerCtrl = [];
          return false;
      }

      // cartページでのみupdate処理を走らせる
      // productsページでは処理を走らせない
      let path = location.pathname;
      if(e.type == 'blur') {
          if (path == '/cart') {
            updateItemQty($(target));
            return false;
          }
      }

      //長押し時の処理
      // setTimeout(function(){
      //     // インターバル未実行中 + 長押しのイベントタイプスタンプ一致時に計算処理
      //     if(!arySpinnerCtrl['interval'] && arySpinnerCtrl['timestamp'] == e.timeStamp){
      //         arySpinnerCtrl['interval'] = setInterval(spinnerCal, spin_speed);
      //     }
      // }, 500);
  });

  //長押し解除時 画面スクロールも解除に含む
  $(document).on('touchend mouseup scroll', function(e){
      if(arySpinnerCtrl['interval']){
          clearInterval(arySpinnerCtrl['interval']);
          arySpinnerCtrl = [];
      }
  });

  //変動計算関数
  function spinnerCal(){
      var target = $(arySpinnerCtrl['target']);
      var num = Number(target.val());
      num = num + arySpinnerCtrl['cal'];
      if(num > Number(target.data('max'))){
          target.val(Number(target.data('max')));
      }else if(target.attr('min') > num){
          target.val(target.attr('min'));
      }else{
          target.val(num);
      }

      const qty = document.getElementById('js-quantity');
      if (qty) {
        const event = new Event('change');
        qty.dispatchEvent(event);
      }
  }

  // cartのupdate
  function updateItemQty(target) {
    let key = target.data('item-variant-id');
    let qty = target.val();

    jQuery.post('/cart/update.js', 'updates[' + key + ']=' + qty).always(function() {
      location.reload();
    });
  }

});





//.numberComma で数値をカンマ区切り
var targetClass = '.number-comma';
var digitUnit = 3;
/*
ページ内カンマ自動制御
----------------------------------------------------------------------*/
$(document).ready(loadComma);
function loadComma() {
    $(targetClass).each(function () {
        if ($(this).text().indexOf(",") == -1 && !($(this).text().match(/[^0-9]+/))) {
            $(this).html(commaDelim($(this).text()));
        }
    });
}
/*
価格数値カンマ制御
----------------------------------------------------------------------*/
function commaDelim(str) {
    if (str.length > 3) {
        var oriStr = str;
        var num = Math.floor(str.length / digitUnit);
        var measure = str.length / 3 - Math.floor(str.length / digitUnit);
        measure = Math.floor(measure * 10);
        measure = measure / digitUnit;
        str = "";
        if (measure > 0) str = oriStr.slice(0, measure);
        for (var i = 0; i < (num); i++) {
            if (str != "") str += ",";
            str += oriStr.slice(measure + i * digitUnit, measure + (i + 1) * digitUnit);
        }
    }
    return str;
}



//instafeed
$(window).on('load', function () {
  var count = 0;
  var limit = 9;
  var text = '';
  var data;
  var graph_api = 'https://graph.facebook.com/v5.0/';
  var accessToken = 'EAAUnpLNtB9EBADMxVBdiVkvM32RgrfZBUTPorZAWglcD78oNoeRlxYu89JZCcsArB72mZCdCIqJfswyEf7EsO4qmWmCTQR2PbFUTWpIpyHHADw31P9eWL0xoiWkP8vMGq1brYMxNKel8gXrgTwAnB9JH502WAcaC62ehDKC7elKTnuNZCJZB6FmiZBF7Yiz2rQZD';
  var businessID = '17841405920772032';
  var fields = 'media{caption,media_url,permalink,timestamp,username,thumbnail_url}';
  var url = graph_api + businessID + '?fields=' + fields + "&access_token=" + accessToken;
  $.ajax({
    url: url
  })
  .done(function(res) {
    data = res.media;
    count = 0;
    $.each(data, function(index, val) {
      $.each(val, function(i, elem) {
        if (elem.media_url && count < limit) {
          if(elem.thumbnail_url) {
            text2 = '<img src="'+elem.thumbnail_url+'">';
          } else {
            text2 = '<img src="'+elem.media_url+'">';
          }
          text1 = '<li><a href="'+elem.permalink+'" target="_blank">';
          text3 = '</a></li>';
          count ++;
          text = text + text1 + text2 + text3;
        }
      });
    });
    //text = '<ul>' + text + '</ul>';
    $('#instafeed').append(text);

    if($('.insta-slide').length){
      if (window.matchMedia('(min-width: 860px)').matches) {
        $('.insta-slide').not('.slick-initialized').slick({
          autoplay: false,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          fade: false,
          speed: 1000,
          centerMode: true,
          centerPadding: '30px',
          autoplaySpeed: 4000,
          dots: false
        });
      }
    }
  })
  .fail(function(jqXHR, status) {
    $('#instafeed').html('<li></li>');
  })
});





